import React, { createContext, useContext, useReducer } from 'react';
import { IinitialState } from '../models/ilp-page-models';


export const ILPPageContext = createContext(null);
export const ILPPageDispatchContext = createContext(null);

interface providerState {
    initialState: IinitialState,
    children?: React.ReactNode
}

interface providerActions {
    type: string,
    data?: any
}

export function ILPPageProvider({ initialState, children }: providerState) {
    const [state, dispatch] = useReducer(
        stateReducer,
        initialState
    );

    return (
        <ILPPageContext.Provider value={state}>
            <ILPPageDispatchContext.Provider value={dispatch}>
                {children}
            </ILPPageDispatchContext.Provider >
        </ILPPageContext.Provider>

    );
}

export function useILPPageContext() {
    return useContext(ILPPageContext);
}

export function useILPPageDispatch() {
    return useContext(ILPPageDispatchContext);
}

function stateReducer(state: IinitialState, action: providerActions) {
    switch (action.type) {
        case 'updateOrganization': {
            const url = new URL(window.location.href);
            url.searchParams.set('organizationKey', action.data);
            window.history.replaceState(null, null, url);
            return {
                ...state,
                selectedOrg: action.data
            }
        }
        case 'updateLoadingStatus': {
            return {
                ...state,
                isLoading: action.data
            }
        }
        case 'updateFormError': {
            return {
                ...state,
                formError: action.data
            }
        }
        case 'updatePlans': {
            return {
                ...state,
                plans: action.data
            }
        }
        default: {
            return state;
        }
    }
}